import { util } from 'echarts/core';
import { type ThemeParser } from '../../core/theme';
import { normalizeToArray } from '../../util/utils';

const formatData = (data, dvMinPercent: number) => {
  if (!dvMinPercent) {
    return data;
  }
  const totalNum = data.reduce((res: number, i) => (i.value >= 0 ? res + i.value : res), 0);
  const min = totalNum * dvMinPercent || 0;
  return data.map(i => {
    const value = i.value < 0 || i.value < min ? min : i.value;
    return {
      ...i,
      originValue: i.value,
      value
    };
  });
};

function parseTreemap(option: Parameters<ThemeParser>[0]) {
  option.dvInteraction = {
    enablePageScrollX: true
  };
  option.series = option.series.map(item => {
    if (item.type !== 'treemap') {
      return item;
    }
    const newoption = util.merge(
      {
        type: 'treemap',
        width: '100%',
        height: '100%',
        roam: false,
        squareRatio: 1,
        nodeClick: false,
        emphasis: {
          disabled: true
        },
        breadcrumb: {
          show: false
        },
        itemStyle: {
          gapWidth: 2, // 两个方块之间的间距
          borderColor: 'transparent'
        },
        label: {
          padding: 4,
          formatter: params => {
            const { name, labelValue } = params.data;
            return `{name|${name}}\n{value|${labelValue}}`;
          },
          width: '100%',
          height: '100%',
          overflow: 'none',
          rich: {
            name: {
              align: 'center',
              color: '#fff',
              fontSize: 12,
              dvLineHeight: 14 / 12,
              dvMinFontSize: 10
            },
            value: {
              align: 'center',
              color: '#fff',
              fontFamily: 'THSJinRongTi-Medium',
              fontSize: 12,
              dvMinFontSize: 6,
              dvLineHeight: 14 / 12,
              padding: [2, 0, 0, 0],
              dvValueFontDeviation: 3 // 处理名称字号校准
            }
          }
        },
        dvLabelType: 'staticCenter',
        dvLabelShowTimer: 100,
        animation: false
      },
      item,
      true
    );
    return {
      ...newoption,
      data: formatData(newoption.data, newoption.dvMinPercent)
    };
  });
}

/**
 * 移动端主题-矩形树图解析器
 */
export function businessTreemapMarketLightParse(
  ...args: Parameters<ThemeParser>
): ReturnType<ThemeParser> {
  const option = args[0];
  const series = normalizeToArray(option.series);
  if (series.find(i => i.type === 'treemap')) {
    parseTreemap(option);
  }
}
